import { CONSIGNMENT_ONBOARDING_TAB } from "@/core/helpers/consignmentOnboardingTab";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Pilot invites live on the Onboarding page, under Registration access.
export const Route = createFileRoute(
	"/admin/consignment-vendor-application-invite/",
)({
	beforeLoad() {
		throw redirect({
			to: "/admin/consignment-onboarding",
			search: { tab: CONSIGNMENT_ONBOARDING_TAB.RegistrationAccess },
			replace: true,
		});
	},
});
